module.exports = __webpack_public_path__ + "static/media/arrow_right_blue.fd93d8e8.svg";